import SubscriptionPlans from '../../modals/components/layouts/business-dashboard/BusinessViewStudent/SubscriptionPlans/SubscriptionPlans';

export default function Subscription() {
  return (
    <>
      <SubscriptionPlans />
    </>
  );
}
